import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import ProjekteView from "@/views/ProjekteView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import ProjektDetails from "@/components/ProjektDetails.vue";
import DatenschutzView from "@/views/DatenschutzView.vue";
import ReferenzenView from "@/views/ReferenzenView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/ueberuns",
    name: "ueberuns",
    component: AboutView,
  },
  {
    path: "/projekte",
    name: "projekte",
    component: ProjekteView,
  },
  {
    path: "/projekte",
    name: "projekte",
    component: ProjekteView,
  },
  ,
  {
    path: "/impressum",
    name: "impressum",
    component: ImpressumView,
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: DatenschutzView,
  },
  {
    path: "/referenzen",
    name: "referenzen",
    component: ReferenzenView,
  },
  {
    path: "/projekte/:URLtitle/:id",
    name: "ProjektDetails",
    component: ProjektDetails,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});

export default router;
